module.exports = __webpack_public_path__ + "static/img/bg_blur01.662ec3eb.jpg";